import { useEffect, useState } from "react";
import Table from "../../Reusable/Table/Table1";
import {
  CheckCircleOutlined,
  EditOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import DropdownButton from "../../Reusable/dropdown/Drop";
import ReusableModal from "../../Reusable/Model/Model";
import ReusableDrawer from "../../Reusable/Drawer/Drawer";
import { Form, Input, Radio, InputNumber, Tag } from "antd";

import { Button, message, Select } from "antd";
import CustomSelect from "../../Reusable/Select/Select";
import AvatarUploader from "../../Reusable/Avatar/Avatar";
import axios from "axios";
import consts from "../../constant";
import EditableTable from "../../Reusable/Table/EditableTable";
import Tab from "../../Reusable/Tab/Tab";
import Table1 from "../../Reusable/Table/Table1";
import formatCustomDate from "../../helpers/formatDateandTime";
import Loadingpage from "../Loadingpage/Loadingpage";
import { DatePicker } from "antd";
import dayjs from "dayjs";
const { RangePicker } = DatePicker;
const formatedDateTime = (date) => {
  const dateObj = new Date(date);
  const formattedDate = dateObj.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  const formattedTime = dateObj.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  return `${formattedDate} ${formattedTime}`;
};
const TradeHistory = () => {
  const [open, setOpen] = useState(false);
  const [openBlock, setOpenBlock] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState("Content of the modal");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [orderTyp, setOrderTyp] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm();
  const [formLayout, setFormLayout] = useState("vertical");
  const [selected, setSelected] = useState("Percentage");
  const [avatar, setAvatar] = useState(localStorage.getItem("avatar") || null);
  const [page, setPage] = useState({ current: 1, pageSize: 10 });
  const [history, setHistory] = useState([]);
  const [option, setOption] = useState("completed");
  const [miscoption, setMiscOption] = useState("limit");
  const [totalPage, setTotalPage] = useState([]);
  const [search, setSearch] = useState("");
  const [result, setResult] = useState("");
  const [direction, setDirection] = useState("");
  const [futureStartDate, setFutureStartDate] = useState(
    dayjs().subtract(6, "day"),
  );
  const [endFutureDate, setEndFutureDate] = useState(dayjs());
  console.log(orderTyp, "orderTyp");

  const handleChange = (value) => {
    console.log("Selected:", value);
    setSelected(value);
  };

  const options = [
    { value: "completed", label: "Completed" },
    { value: "canceled", label: "Cancelled" },
  ];

  const miscoptions = [
    { value: "market", label: "Market" },
    { value: "limit", label: "Limit" },
  ];

  const success = () => {
    messageApi.open({
      type: "success",
      content: "User Blocked",
    });
  };

  const showDrawer = (user) => {
    setSelectedUser(user);
    setOpenDrawer(true);
  };

  const onClose = () => {
    setOpenDrawer(false);
    setSelectedUser(null);
  };

  const handleOk = () => {
    setModalText("The modal will be closed after two seconds");
    setConfirmLoading(true);
    setTimeout(() => {
      setOpen(false);
      setConfirmLoading(false);
    }, 2000);
  };

  const handleOkBlock = () => {
    setModalText("The modal will be closed after two seconds");
    setConfirmLoading(true);
    setTimeout(() => {
      setOpenBlock(false);
      setConfirmLoading(false);
      success();
    }, 2000);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleCancelBlock = () => {
    setOpenBlock(false);
  };

  const handleMenuClick = (e, user) => {
    console.log("Clicked:", e);
    if (e.key === "1") {
      // View
      showDrawer(user);
    }
  };

  const handleAvatarChange = (url) => {
    setAvatar(url);
    localStorage.setItem("avatar", url); // persist locally
  };
  const items = (user) => [{ label: "Edit", key: "1", icon: <EditOutlined /> }];

  const userColumns = [
    { title: "Sno", dataIndex: "sno", key: "sno" },
    // { title: "User", dataIndex: "user", key: "user" },
    { title: "Date & Time", dataIndex: "createdAt", key: "createdAt" },
    { title: "Pair", dataIndex: "symbol", key: "symbol" }, // editable
    { title: "Direction", dataIndex: "direction", key: "direction" },
    { title: "Start Time", dataIndex: "startTime", key: "startTime" },
    {
      title: "End Time",
      dataIndex: "endTime",
      key: "endTime",
    },
    { title: "Start Price", dataIndex: "start_price", key: "start_price" },
    { title: "End Price", dataIndex: "end_price", key: "end_price" },
    {
      title: "Result",
      dataIndex: "result",
      key: "result",
    },
    {
      title: "Betting Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Received Amount",
      dataIndex: "received_amount",
      key: "received_amount",
    },
  ];

  const getTradeHistory = async () => {
    try {
      const payload = {
        start: futureStartDate,
        end: endFutureDate,
        search: search,
        result: result,
        direction: direction,
      };

      console.log(page.current, "page");
      const { data } = await axios.post(
        `${consts.BackendUrl}/users/getTradeHistory?page=${page?.current ? page?.current : 1
        }&limit=10`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        },
      );

      if (data?.success == true) {
        var dts = data?.result;
        setTotalPage(data?.total);
        console.log(data, "histdata");

        // var totalCount = data?.result?.totalDocs;
        // Map backend data into the table format
        const mappedData = dts.map((user, index) => {
          // if you want to store something in state, do it outside the return

          setOrderTyp(user);
          console.log(user, "user");
          // console.log(newValues, "newvalues");
          return {
            ...user,
            key: index, // REQUIRED for AntD Table
            sno: page?.current
              ? (page?.current - 1) * page?.pageSize + index + 1
              : index + 1,

            createdAt: formatCustomDate(user?.createdAt),
            symbol: user?.pair,
            direction: user?.direction,
            startTime: formatCustomDate(user?.startTime),
            endTime: formatCustomDate(user?.endTime),
            start_price: user?.start_price,
            end_price: user?.end_price,
            result: user?.result ? "Win" : "Lost",
            amount: user?.quantity,
            received_amount: user?.result ? (
              <span style={{ color: "green" }}>+ {user?.received_amount}</span>
            ) : (
              <span style={{ color: "red" }}>- {user?.received_amount}</span>
            ),
          };
        });

        console.log(mappedData, "dts");
        // setTotalPage(totalCount)
        setHistory(mappedData);
      } else {
        setHistory([]);
        setTotalPage(0);
      }
    } catch (error) {
      console.log(error?.message, "error");
      setHistory([]);
      setTotalPage(0);
    }
  };
  const handleFuturedate = (date) => {
    if (!date) {
      setFutureStartDate(null);
      setEndFutureDate(null);
      return;
    }
    setPage({ current: 1, pageSize: 10 });
    setFutureStartDate(date[0]);
    setEndFutureDate(date[1]);
    getTradeHistory();
  };
  const newValues = (values) => {
    console.log(values, "values");
    editTrade(values);
  };
  const editTrade = async (trade) => {
    console.log(trade, "tradeId");

    try {
      const { data } = await axios.post(
        `${consts.BackendUrl}/editTradeHistory`,
        {
          ...trade,
        },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        },
      );

      if (data?.success) {
        messageApi.open({
          type: "success",
          content: "Trade Edited successfully",
        });
        getTradeHistory(); // refresh table after closing
      }
    } catch (error) {
      console.log(error?.response?.data?.message);
      message.error("Failed to edit trade");
    }
  };

  const handlePagination = (pagination) => {
    console.log("Table params:", pagination);
    setPage(pagination);
  };
  const handleSearch = (value) => {
    setPage({ current: 1, pageSize: 10 });
    console.log(value?.target?.value, "value");
    setSearch(value?.target?.value);
  };

  useEffect(() => {
    console.log("hjh");

    getTradeHistory();
  }, [
    option,
    page,
    miscoption,
    futureStartDate,
    endFutureDate,
    search,
    result,
    direction,
  ]);
  return (
    <>
      <Loadingpage />
      <div className="display-2 p-10">
        <h2>Trade Orders</h2>
      </div>
      {/* <Radio.Group
    value={option}
    options={[
      { value: "all", label: 'All' },
      { value: "pending", label: 'Pending' },
      { value: "completed", label: 'Completed' },
      {value: "canceled", label: 'Cancelled' },
    ]}
    onChange={(e) => setOption(e.target.value)}
  /> */}

      <div className="display-2 p-10 tabs-custom-cls">
        {/* <Tab onChange={setOption} options={options} /> */}
        {/* <Tab onChange={setMiscOption} options={miscoptions}   /> */}
        <div></div>
        <div>
          {/* <CustomSelect
            onChange={setMiscOption}
            style={{ width: 100 }}
            options={miscoptions}
            defaultValue={miscoption}
            className="selected-cls"
          /> */}
          <Select
            value={result}
            style={{ width: 100 }}
            onChange={(e) => {
              setResult(e);
              setPage({ current: 1, pageSize: 10 });
            }}
          >
            <Select.Option value={""}>All</Select.Option>
            <Select.Option value={"true"}>Win</Select.Option>
            <Select.Option value={"false"}>Lost</Select.Option>
          </Select>
          <Select
            value={direction}
            style={{ width: 100 }}
            onChange={(e) => {
              setDirection(e);
              setPage({ current: 1, pageSize: 10 });
            }}
          >
            <Select.Option value={""}>All</Select.Option>
            <Select.Option value={"high"}>High</Select.Option>
            <Select.Option value={"low"}>Low</Select.Option>
          </Select>
          <Input
            style={{ marginLeft: 10, width: 250 }}
            placeholder="Search"
            onChange={handleSearch}
          />
          <RangePicker
            style={{ marginLeft: 10, width: 250 }}
            onChange={handleFuturedate}
            value={[futureStartDate, endFutureDate]}
            className="input-cls"
          />
        </div>
      </div>

      <EditableTable
        columnsConfig={userColumns}
        dataSource={history}
        className="mt-20 tradrtable"
        total={totalPage} // 👈 pass backend total here
        pageSize={page?.pageSize ? page?.pageSize : 10}
        current={page?.current ? page?.current : 1}
        closeDisabled={true}
        onChange={handlePagination}
      // completeTrade={editTrade}
      // newValues={newValues}
      />

      <ReusableModal
        title="Confirm Delete"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
      >
        <p>{modalText}</p>
      </ReusableModal>
      <ReusableModal
        title="Confirm Block"
        open={openBlock}
        onOk={handleOkBlock}
        confirmLoading={confirmLoading}
        onCancel={handleCancelBlock}
      >
        <p>{modalText}</p>
      </ReusableModal>

      <ReusableDrawer
        open={openDrawer}
        onClose={onClose}
        title="Edit History"
        extra={<CloseCircleOutlined className="cursor" onClick={onClose} />}
      >
        {selectedUser ? (
          <div>
            <Form
              layout={formLayout}
              form={form}
              style={{ maxWidth: formLayout === "inline" ? "none" : 600 }}
            >
              {/* <Form.Item label="Asset Image">
                                <AvatarUploader />
                            </Form.Item> */}
              <Form.Item label="Price">
                <InputNumber
                  placeholder="enter base name"
                  style={{ width: "100%" }}
                />
              </Form.Item>
              <Form.Item label="Quantity">
                <InputNumber
                  placeholder="enter market name"
                  style={{ width: "100%" }}
                />
              </Form.Item>

              <Form.Item label="Volume">
                <InputNumber
                  placeholder="enter trade commission"
                  style={{ width: "100%" }}
                />
              </Form.Item>

              <div className="display-2">
                <Button
                  type="primary"
                  color="cyan"
                  variant="solid"
                  // loading={true}
                  iconPosition="end"
                >
                  Approve
                </Button>

                <Button
                  type="primary"
                  variant="outlined"
                  color="danger"
                  // loading={true}
                  iconPosition="end"
                  onClick={onClose}
                >
                  Cancel
                </Button>
              </div>
            </Form>
          </div>
        ) : (
          <p>No user selected</p>
        )}
      </ReusableDrawer>

      {contextHolder}
    </>
  );
};

export default TradeHistory;
